import React from 'react'
import './Message.css'
import chairperson1 from "../../Home/images/Pt Lakhmi Chand Bhardwaj 3.JPG"
import chairperson2 from "../../Home/images/IMG_1351-FILEminimizer-1024x683.jpg"
import chairperson3 from "./photos/WhatsApp Image 2025-02-12 at 10.31.59.jpeg"
import Slider from '../../Home/Slider/Slider'
const Message = () => {
  return (
    <div className='main-container-Message'>
      <Slider></Slider>  
      <div className='message-1'>
      <div data-aos="fade-up"
       data-aos-duration="3000">
       <h1 className='xyz-1'>Message</h1> <br /> <hr />
       </div>
        {/* chairmansection */}
        <div data-aos="fade-up"
     data-aos-duration="3000">

        <div className='message-2'> 
       
        <div className='message-3'> 
          <h3>"Without inspiration the best powers of the mind remain dormant There is a fuel in us which needs to be ignited with sparks"</h3> <br /> <br />
          <p>I am pleased to introduce you to our institution and explore how we connect students to the world of possibilities. Our college is professionally managed and guided with meticulous care with all prudential standards, by the members of the board of management emerging from different disciplines with vast experience, knowledge and academic understanding, with a vision to achieve the most preferred status globally. Our college has acquired an enviable reputation for maintaining the highest order of discipline. Pt. L. R. School of Pharmacy is vitalizing itself to face the challenging technology with an eminent faculty team. They help to produce highly efficient and experienced professionals who can meet the demands of the future and excel in their profession through innovative ideas, knowledge and teamwork. It gives me immense pleasure that the college is providing technical knowledge and the overall growth and development of the budding stars of future India.</p> 
        </div><hr />
        <div className='chairman-image'>
        <div data-aos="flip-up"
          data-aos-anchor-placement="top-bottom">
          <img src={chairperson1 } alt="chairperson2" className='chairman-image-1'/> 
          </div>
          <h1>Dr. L.C. Bhardwaj</h1> <br />
           <h2>Chairman</h2>
        </div>
        </div>  <hr /> 
        </div>



        {/* vice chairman section */}
        <div data-aos="fade-up"
     data-aos-duration="3000">

        <div className='message-4'> 
        <div className='chairman-image'>
        <div data-aos="flip-up"
          data-aos-anchor-placement="top-bottom">
          <img src={chairperson2 } alt="chairperson"className='chairman-image-2'/> 
          </div>
          <h1>Mr. Gaurav Bhardwaj</h1> <br />
           <h2>Vice Chairman</h2>
        </div> <hr />
        <div className='message-5'> 
          <h3>Vice Chairman's Message</h3> <br /> <br />
          <p>Imparting high-quality technical education in line with the current trends in technology embedded with professional skills and nurturing the students with national patriotism as also a commitment to society and humanity, in general, is our primary motto at Pt. L. R. School of Pharmacy.
          All our faculties and supporting staff are striving hard to meet the expectations of our primary stakeholders, the parents and the industries in this regard, and I am confident that the engineers coming out of this esteemed institution tomorrow will take our country to the forefront on the technological map of the world.</p> 
        </div>
        
        </div> <hr />
        </div>
     
          <div data-aos="fade-up"
          data-aos-duration="3000">
        <div className='message-6'> 
        <div className='message-7'> 
          <h3>Principal Message</h3> <br /> <br />
          <p>Education is the cornerstone of your future, and at PT L.R. School Pharmacy, we are committed to helping you unlock your full potential. As you embark on your academic journey, remember that hard work, dedication, and perseverance are essential for success. Embrace every opportunity to learn, grow, and challenge yourself. We are here to guide and support you every step of the way. Let us work together to create an environment where knowledge flourishes, and your dreams become reality. Keep striving for excellence and never stop believing in your abilities.</p> 
        </div><hr />
        <div className='chairman-image'>
        <div data-aos="flip-up"
          data-aos-anchor-placement="top-bottom">
          <img src={chairperson3 } className='chairman-image-3'/> 
          </div>
          <h1>Ms. Reena Kaushik</h1> <br />
           <h2>Principal <br />
           Pt L.R. School  of Pharmacy</h2>
        </div>
        </div>  <hr />
                </div>
      </div>
     </div>
   
  )
}

export default Message
